module.exports = __webpack_public_path__ + "static/img/btn_jiao.25190dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_jiao.png
// module id = lIQ+
// module chunks = 1